export default "__VITE_ASSET__CpFTbMxn__"